import React from "react"

export default function PlanMetricStrip({
  formatMoney,
  totalEstimated,
  totalProduced,
  totalPaid,
  pendingFinancial,
  items,
  counts
}) {
  const totalItems = Array.isArray(items) ? items.length : 0

  return (
    <div
      style={{
        border: "1px solid #e2e8f0",
        background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
        borderRadius: 18,
        padding: 16,
        boxShadow: "0 8px 22px rgba(15,23,42,0.05)"
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 12
        }}
      >
        <CompactMetric
          label="Estimado"
          value={formatMoney(totalEstimated)}
        />
        <CompactMetric
          label="Pagado"
          value={formatMoney(totalPaid)}
        />
        <CompactMetric
          label="Saldo pendiente"
          value={formatMoney(pendingFinancial)}
          tone={pendingFinancial > 0 ? "warning" : "success"}
        />
        <CompactMetric
          label="Ítems pendientes"
          value={String(counts.pending)}
        />
        <CompactMetric
          label="Ítems agendados"
          value={String(counts.scheduled)}
        />
        <CompactMetric
          label="Ítems realizados"
          value={String(counts.done)}
          tone="success"
        />
      </div>

      <div
        style={{
          marginTop: 12,
          fontSize: 12.5,
          color: "#64748b"
        }}
      >
        {totalItems} ítem(s) en el plan · Producido {formatMoney(totalProduced)}
      </div>
    </div>
  )
}

function CompactMetric({ label, value, tone = "neutral" }) {
  const tones = {
    neutral: {
      bg: "#ffffff",
      border: "#e2e8f0",
      value: "#0f172a"
    },
    warning: {
      bg: "#fffbeb",
      border: "#fde68a",
      value: "#92400e"
    },
    success: {
      bg: "#f0fdf4",
      border: "#bbf7d0",
      value: "#166534"
    }
  }

  const visual = tones[tone] || tones.neutral

  return (
    <div
      style={{
        border: `1px solid ${visual.border}`,
        background: visual.bg,
        borderRadius: 14,
        padding: 12
      }}
    >
      <div
        style={{
          fontSize: 11.5,
          color: "#64748b",
          textTransform: "uppercase",
          fontWeight: 900,
          letterSpacing: 0.35
        }}
      >
        {label}
      </div>

      <div
        style={{
          marginTop: 6,
          fontSize: 22,
          fontWeight: 900,
          color: visual.value,
          lineHeight: 1.05,
          letterSpacing: "-0.03em"
        }}
      >
        {value}
      </div>
    </div>
  )
}